import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Alert from "../Elements/Alert";
import { useStateValue } from "../../../store/StateProvider";
import { actionTypes } from "../../../utils/constants";
import constants from "../../../config/constants";
import { getSellerCreationErrors, getFieldValidationErrors } from "../../../utils/validator";

const ThumbnailDropdownControl = ({ fieldConfig, showErrors, onChangeHandler = () => {} }) => {
  let fieldClass = "outline-secondary input_plain width_100 thumbnail_dropdown";
  fieldClass += fieldConfig.class;

  const getDropdownOptionByCountry = country => {
    return fieldConfig.options.find(option => option.value === country);
  };

  const getCurrentValue = () => {
    const currentValue = dataSource[fieldConfig.id] || fieldConfig.default;
    const currentCountry = getDropdownOptionByCountry(currentValue.code ?? currentValue);

    if (currentValue && currentCountry) {
      if (currentCountry) {
        return {
          alt: currentCountry.value,
          src: currentCountry.thumbnail,
          label: currentCountry.label
        };
      }
    }

    return {};
  };

  const [{ formValues, registrationCountry, countryOfSelling, sellerCreationErrors }, dispatch] = useStateValue();
  const dataSource = { ...formValues, registrationCountry, countryOfSelling };
  const currentValue = getCurrentValue();
  const [dropdownValue, setDropdownValue] = useState(currentValue);
  const [dropdownFocus, setDropdownFocus] = useState(false);
  const [errorMessage, setErrorMessage] = useState(getSellerCreationErrors(fieldConfig.id, sellerCreationErrors));

  useEffect(() => {
    if (fieldConfig.defaultOption) {
      setDropdownValue({
        alt: fieldConfig.defaultOption.value,
        src: fieldConfig.defaultOption.thumbnail,
        label: fieldConfig.defaultOption.label
      });
    }
  }, [fieldConfig.defaultOption]);

  useEffect(() => {
    if (showErrors) {
      executeFieldValidation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showErrors]);

  const handleBlur = () => {
    executeFieldValidation();
    setDropdownFocus(false);
  };

  const handleFocus = () => {
    setDropdownFocus(true);
  };

  const executeFieldValidation = () => {
    const error = getFieldValidationErrors(
      fieldConfig.validators,
      { ...formValues, registrationCountry },
      fieldConfig.id
    );
    setErrorMessage(error);
  };

  const thumbnailDropdownItemClickHandler = value => {
    const option = getDropdownOptionByCountry(value);
    setDropdownValue({
      alt: option.value,
      src: option.thumbnail,
      label: option.label
    });
    onChangeHandler(value);
    if (fieldConfig.id === constants.INPUT_ID_COUNTRY_OF_REG) {
      dispatch({
        type: actionTypes.SET_REGISTRATION_COUNTRY,
        payload: {
          [fieldConfig.id]: {
            id: option.id,
            name: option.label,
            code: option.value
          },
          fieldsAutoFilled: [constants.INPUT_ID_COUNTRY_SELLER, constants.INPUT_ID_COUNTRY_SHIPMENT_WH]
        }
      });
    }
  };

  const dropdownSelected = dropdownValue ?? currentValue;

  return (
    <>
      <DropdownButton
        variant={fieldClass}
        title={
          <div>
            {dropdownSelected.src && (
              <img alt={dropdownSelected.alt} src={dropdownSelected.src} className="thumbnail_dropdown_image" />
            )}
            {dropdownSelected.label ?? fieldConfig.placeHolder}
          </div>
        }
        name={fieldConfig.name}
        id={fieldConfig.id}
        onFocus={handleFocus}
        onBlur={handleBlur}
        data-cy={fieldConfig.id}>
        {fieldConfig.options.map(dropdownOption => {
          return (
            <Dropdown.Item
              key={dropdownOption.id}
              id={dropdownOption.id}
              value={dropdownOption.value}
              className="thumbnail_dropdown_item"
              onClick={() => thumbnailDropdownItemClickHandler(dropdownOption.value)}>
              <img alt={dropdownOption.value} src={dropdownOption.thumbnail} />
              &nbsp;
              {dropdownOption.label}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
      {!!errorMessage && !dropdownFocus && (
        <div className="div-alert-country-reg">
          <Alert text={errorMessage} color="var(--white)" backgroundColor="var(--red)" />
        </div>
      )}
    </>
  );
};

export default ThumbnailDropdownControl;
